import clsx from "clsx"
import React from "react"

import styles from "./Divider.module.scss"

type Props = {
	color?:
		| "#5151774D"
		| "rgba(255, 255, 255, 0.4)"
		| "rgba(217, 217, 217, 1)"
		| "rgba(217, 217, 217, 0.5)"
	thickness?: string
	margin?: string
	className?: string
}

const Divider: React.FC<Props> = ({
	color = "#5151774D",
	thickness = "1px",
	margin = "0",
	className,
}) => {
	return (
		<div
			className={clsx(styles.divider, className)}
			style={{backgroundColor: color, height: thickness, margin}}
		/>
	)
}

export default Divider
